"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteField = void 0;
const command_manager_1 = require("../../command_manager");
const field_1 = require("../../commands/common/field");
const engine_1 = require("../../engine");
const i18n_1 = require("../../exports/i18n");
const model_1 = require("../../model");
const store_1 = require("../../exports/store");
const types_1 = require("../../types");
exports.deleteField = {
    undoable: true,
    execute: (context, options) => {
        const { model: state } = context;
        const { data, datasheetId: _datasheetId } = options;
        const datasheetId = store_1.Selectors.getActiveDatasheetId(state);
        const snapshot = store_1.Selectors.getSnapshot(state, _datasheetId || datasheetId);
        if (!snapshot) {
            return null;
        }
        const actions = [];
        const linkedActions = [];
        // delete all cellValues of this field
        data.forEach(({ fieldId }) => {
            if (!snapshot.meta.fieldMap[fieldId]) {
                throw new Error((0, i18n_1.t)(i18n_1.Strings.field_had_deleted));
            }
            for (const recordId in snapshot.recordMap) {
                const action = model_1.DatasheetActions.setRecord2Action(snapshot, { recordId, fieldId, value: null });
                action && actions.push(action);
            }
            // For LastModifiedBy/LastModifiedTime field type, fieldIdCollection needs to be updated
            const newActions = (0, field_1.setAffectFieldAttr2Action)(snapshot, fieldId);
            actions.push(...newActions);
        });
        const { viewId } = state.pageParams;
        const collected = data.reduce((collected, { fieldId, deleteBrotherField }) => {
            const field = snapshot.meta.fieldMap[fieldId];
            if (field.type === types_1.FieldType.Link) {
                const linkedAction = (0, field_1.clearOldBrotherField)(context, field, deleteBrotherField);
                linkedAction && linkedActions.push(linkedAction);
            }
            let action = model_1.DatasheetActions.deleteField2Action(snapshot, {
                fieldId, datasheetId, viewId
            });
            if (!action) {
                return collected;
            }
            if (collected.length) {
                action = engine_1.jot.transform(action, collected, 'right');
            }
            collected.push(...action);
            return collected;
        }, []);
        actions.push(...collected);
        console.log({ actions });
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: _datasheetId || datasheetId,
            resourceType: types_1.ResourceType.Datasheet,
            actions,
            linkedActions,
        };
    },
};
/*

 declare module '../../command_manager/command_manager' {
 interface CollaCommandManager {
 execute(options: IAddRecordsOptions & { cmd: 'AddRecords' }): ICollaCommandExecuteResult<IAddRecordsResult>;
 }
 }

 */
//# sourceMappingURL=delete_field.js.map